<full-modal-config
    [modalTitle]="modalTitle"
    (onCancel)="handleCancel()"
    (onSubmit)="handleSubmit()"
    [valid]="form.valid"
    [modified]="form.touched && form.dirty"
    [busy]="busy"
    [errors]="errors"
    submitButtonText="{{ l10nKeys.submitLabel | vtranslate }}"
>
    <form
        clrForm
        #form="ngForm"
        [clrLayout]="verticalLayout"
    >
        <full-modal-tab-section tabTitle="{{ globalL10nKeys.generalLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ globalL10nKeys.generalLabel | vtranslate }}</h3>
                <avi-input-container *ngIf="!showTextOnly">
                    <label
                        aviLabelWithTooltip
                        for="to-emails"
                        [objectType]="objectType"
                        fieldName="to_emails"
                        [required]="!disableEditRecipients"
                    >
                        {{ l10nKeys.toLabel | vtranslate }}
                    </label>
                    <input
                        clrInput
                        id="to-emails"
                        name="to-emails"
                        type="email"
                        regexPattern="email"
                        [(ngModel)]="config.to_emails"
                        [disabled]="disableEditRecipients"
                        [required]="!disableEditRecipients"
                        placeholder="{{ l10nKeys.emailInputPlaceholder | vtranslate }}"
                    />
                </avi-input-container>
                <avi-input-container *ngIf="!showTextOnly">
                    <label
                        aviLabelWithTooltip
                        for="cc-emails"
                        [objectType]="objectType"
                        fieldName="cc_emails"
                    >
                        {{ l10nKeys.ccLabel | vtranslate }}
                    </label>
                    <input
                        clrInput
                        id="cc-emails"
                        name="cc-emails"
                        type="email"
                        regexPattern="email"
                        [(ngModel)]="config.cc_emails"
                        [disabled]="disableEditRecipients"
                        placeholder="{{ l10nKeys.ccEmailInputPlaceholder | vtranslate }}"
                    />
                </avi-input-container>
                <avi-input-container *ngIf="!showTextOnly">
                    <label
                        aviLabelWithTooltip
                        for="subject"
                        [objectType]="objectType"
                        fieldName="subject"
                        required
                    >
                        {{ l10nKeys.subjectLabel | vtranslate }}
                    </label>
                    <input
                        clrInput
                        id="subject"
                        name="subject"
                        type="text"
                        [(ngModel)]="config.subject"
                        placeholder="{{ l10nKeys.subjectLabel | vtranslate }}"
                        required
                    />
                </avi-input-container>
                <avi-textarea-container>
                    <label
                        aviLabelWithTooltip
                        objectType="{{ objectType }}"
                        fieldName="text"
                        for="text"
                        required
                    >
                        {{ textLabel }}
                    </label>
                    <textarea
                        clrTextarea
                        id="text"
                        [(ngModel)]="config.text"
                        name="text"
                        rows="10"
                        required
                    ></textarea>
                </avi-textarea-container>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
